import {Table} from 'antd';
import {useCallback, useContext, useMemo} from 'react';

import {MainFilterContext} from '../../../../../../../provider/main-filter/main-filter';
import {MainFilterContextType} from '../../../../../../../provider/main-filter/main-filter-type';
import {useUserTags} from '../../../../../../../service/reivew-analysis/review-analytics-tags/review-analytics-tag-hook';
import {
    ReviewsAnalysisUserTagType,
    ReviwsAnalysisUserTagTableDataType,
} from '../../../../../../../service/reivew-analysis/review-analytics-tags/review-analytics-tags-type';
import {ReviewsAndAnswersStatisticsUnitMeasurementEnum} from '../../../../../../../service/reviews-and-answers-statistics/reviews-and-answers-statistics';
import {useReviewsAnalysisFilter} from '../../../../reviews-analysis-hook';
import {userTagsPageTableColumns} from '../../keywords-and-topics-page-helper';

export function UserTagsTableSingle(): JSX.Element {
    const {singleFilter} = useReviewsAnalysisFilter();

    const {mainFilterKey} = useContext<MainFilterContextType>(MainFilterContext);

    const {data, isLoading, pagination} = useUserTags(singleFilter, mainFilterKey);

    const getDataSource = useCallback((array: Array<ReviewsAnalysisUserTagType>) => {
        return array.map<ReviwsAnalysisUserTagTableDataType>(
            (tagItem: ReviewsAnalysisUserTagType, index): ReviwsAnalysisUserTagTableDataType => ({
                key: `${tagItem.title} + ${index}`,
                ...tagItem,
            })
        );
    }, []);

    const dataSource: Array<ReviwsAnalysisUserTagTableDataType> = useMemo<Array<ReviwsAnalysisUserTagTableDataType>>(
        (): Array<ReviwsAnalysisUserTagTableDataType> => getDataSource(data?.results || []),
        [getDataSource, data]
    );

    return (
        <Table<ReviwsAnalysisUserTagTableDataType>
            columns={userTagsPageTableColumns({
                timeUnit: singleFilter.timeFormat || ReviewsAndAnswersStatisticsUnitMeasurementEnum.Minutes,
            })}
            dataSource={dataSource}
            loading={isLoading}
            pagination={{
                size: 'default',
                showSizeChanger: true,
                hideOnSinglePage: false,
                current: pagination.page,
                pageSize: pagination.pageSize,
                total: pagination.total,
                onChange: pagination.onChange,
            }}
            scroll={{x: true}}
            size="middle"
        />
    );
}
